import {ApplicationInsights} from '@microsoft/applicationinsights-web';
import DeviceInfo from 'src/nativeModules/DeviceInfo';
import Settings from 'src/Settings';
type Properties = Record<string, string>;
const AppInsights = new ApplicationInsights({
  config: {
    instrumentationKey: Settings.appInsightsKey,
  },
});
AppInsights.loadAppInsights();

class Analytics {
  appVersion = '';

  constructor() {
    this.setApplicationVersion();
  }

  async setApplicationVersion() {
    this.appVersion = `v${await DeviceInfo.getVersion()} (${await DeviceInfo.getBuildNumber()})`;
  }

  trackEvent(eventName: string, properties?: Properties) {
    AppInsights.trackEvent({
      name: eventName,
      properties,
      //application_Version: this.appVersion,
    });
  }

  trackPageView(screen: string, properties?: Properties) {
    AppInsights.trackPageView({
      name: screen,
      properties,
      //application_Version: this.appVersion,
    });
  }
}

export default new Analytics();
